const pagination1 = (editor) => {

    editor.BlockManager.add(`Pagination1`, {
        category: 'Components',
        label: `
          <svg width='1.2vw' height='1.2vw' viewBox="0 -122 512.001 512"  xmlns="http://www.w3.org/2000/svg"><path d="m378.03125 268.988281-28.25-28.269531 105.816406-105.746094-105.882812-106.839844 28.382812-28.132812 133.902344 135.109375zm-215.8125-28.269531-105.816406-105.746094 105.886718-106.839844-28.386718-28.132812-133.902344 135.109375 133.96875 133.878906zm113.765625-105.757812c0 11.015624-8.964844 19.980468-19.984375 19.980468s-19.980469-8.964844-19.980469-19.980468c0-11.019532 8.960938-19.984376 19.980469-19.984376s19.984375 8.964844 19.984375 19.984376zm79.929687 0c0 11.015624-8.964843 19.980468-19.984374 19.980468-11.019532 0-19.980469-8.964844-19.980469-19.980468 0-11.019532 8.960937-19.984376 19.980469-19.984376 11.019531 0 19.984374 8.964844 19.984374 19.984376zm-159.859374 0c0 11.015624-8.964844 19.980468-19.984376 19.980468-11.019531 0-19.980468-8.964844-19.980468-19.980468 0-11.019532 8.960937-19.984376 19.980468-19.984376 11.019532 0 19.984376 8.964844 19.984376 19.984376zm0 0"/></svg>
          <div class="gjs-fontFamily gjs-block-label">Pagination 1</div>
          `,
        attributes: {},
        content: `
            <nav aria-label="Page navigation example">
              <ul pagination-list=true class="pagination">
                <li class="page-item" pagination-previous=true><a class="page-link" href="#">Previous</a></li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item" pagination-next=true><a class="page-link" href="#">Next</a></li>
              </ul>
            </nav>
          `
      });
}

export default pagination1;